import { createActions } from 'redux-actions';

const actions = createActions({
  REFRESH_PETS_AFTER_SUBMIT: () => { },
  REFRESH_PETS_AFTER_SUBMIT_DONE: () => { },
  RESET_NO_MATCH_ERROR: () => { },
  RESET_PET_DEMOGRAPHICS_SUBMIT: () => { },
  SUBMIT_PET_DEMOGRAPHICS: (data) => data,
  SUBMIT_PET_DEMOGRAPHICS_FAILURE: () => { },
  SUBMIT_PET_DEMOGRAPHICS_SUCCESS: () => { },
  UPDATE_CUSTOMER_EMAIL: (data) => data,
  UPDATE_CUSTOMER_EMAIL_FAILED: (data) => data,
  UPDATE_CUSTOMER_EMAIL_SUCCESS: () => { },
  VALIDATE_CERTIFICATE_ZIP_CODE: (data) => data,
  VALIDATE_CERTIFICATE_ZIP_CODE_ATTEMPT: () => { },
  VALIDATE_CERTIFICATE_ZIP_CODE_FAILED: () => { },
  VALIDATE_CERTIFICATE_ZIP_CODE_SUCCESS: () => { },
  VALIDATE_EMAIL: (data) => data,
  VALIDATE_EMAIL_FAILED: (data) => data,
  VALIDATE_EMAIL_SUCCESS: (data) => data,
  VERIFY_CUSTOMER: (data) => data,
  VERIFY_CUSTOMER_FAILED: (data) => data,
  VERIFY_CUSTOMER_SUCCESS: (data) => data,
});

export const {
  refreshPetsAfterSubmit,
  refreshPetsAfterSubmitDone,
  resetNoMatchError,
  resetPetDemographicsSubmit,
  submitPetDemographics,
  submitPetDemographicsFailure,
  submitPetDemographicsSuccess,
  updateCustomerEmail,
  updateCustomerEmailFailed,
  updateCustomerEmailSuccess,
  validateCertificateZipCode,
  validateCertificateZipCodeAttempt,
  validateCertificateZipCodeFailed,
  validateCertificateZipCodeSuccess,
  validateEmail,
  validateEmailFailed,
  validateEmailSuccess,
  verifyCustomer,
  verifyCustomerFailed,
  verifyCustomerSuccess,
} = actions;
